// React
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// Material UI
import { Box, Button, Container, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

// Hooks and utils
import pageTitle from 'src/utils/pageHelper';
import { appConfig } from 'src/config/config';
import { useTranslation } from 'react-i18next';

const ServerError: FC = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const { t: translate } = useTranslation();
  const { backToHome } = appConfig.i18n.actions;
  const {
    pageTitle: pageTitle500,
    errorSummary,
    svgAltDescription
  } = appConfig.i18n.pages.errors.serverError;

  return (
    <>
      <Helmet>
        <title>
          { pageTitle(pageTitle500) }
        </title>
      </Helmet>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          px: 1,
          py: 2
        }}
      >
        <Container maxWidth="lg">
          <Typography
            align="center"
            color="textPrimary"
            variant={mobileDevice ? 'h4' : 'h1'}
          >
            {translate(errorSummary)}
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            {window.localStorage[appConfig.errors.lastSystemErrorKey] !== '' && <div>{window.localStorage[appConfig.errors.lastSystemErrorKey]}</div>}
            {window.localStorage[appConfig.errors.lastSystemErrorKey] === '' && <div>{translate(appConfig.i18n.messages.genericIntenralServerMessage)}</div>}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            <Box
              alt={translate(svgAltDescription)}
              component="img"
              src={`/static/error/error500_${theme.palette.mode}.svg`}
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: 300
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            <Button
              color="primary"
              component={RouterLink}
              to="/"
              variant="outlined"
            >
              {translate(backToHome)}
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ServerError;
